import { useState } from 'react';

import { Button } from 'react-bootstrap';

import MyOrdersDetailsData from './MyOrdersDetailsDataComponent';
import ModalCancelOrder from '../../../common/components/ModalCancelOrder';
import { ITenant } from '../../serviceOrdering/reducers';

const MyOrdersDetails = (_props: any) => {
  const [category, setCategory] = useState('preview');

  const [showOrderCancelModal, setShowOrderCancelModal] = useState(false);

  const archiveOrder = () => {
    //TODO IMPLEMENTATION
  };

   
  const [prestation] = useState('entry');
   
  const [diagnostician] = useState('dwell');
  const [tenantInfos, setTenantInfos] = useState({ firstname: '', name: '', phone: '', email: '' });
  const [formerTenantInfos, setFormerTenantInfos] = useState({ firstname: '', lastname: '' });
  const [incomingTenantInfos, setIncomingTenantInfos] = useState<Array<ITenant>>([]);
  const [previousTenantInfos, setPreviousTenantInfos] = useState<Array<ITenant>>([]);
  const [entryDate, setEntryDate] = useState(new Date());
  const [diagnosticDate, setDiagnosticDate] = useState(new Date());
  const [leavingTenantEntryDate, setLeavingTenantEntryDate] = useState(new Date());
  const [appointment, setAppointment] = useState('dwell');
  const [appointmentTime, setAppointmentTime] = useState('11:00');

  const changeTenantInfos = (e: any) => {
    setTenantInfos({ ...tenantInfos, [e.target.name]: e.target.value });
  };

  const changeIncomingTenantInfos = (e: any, index: number) => {
    const copyIncoming = [...incomingTenantInfos];
    copyIncoming[index] = { ...incomingTenantInfos[index], [e.target.name]: e.target.value };
    setIncomingTenantInfos(copyIncoming);
  };

  const addIncomingTenant = () => {
    setIncomingTenantInfos([
      ...incomingTenantInfos,
      { firstname: '', name: '', phone: '', email: '', state: 'incoming' }
    ]);
  };

  const deleteIncomingTenant = (index: number) => {
    const copyIncoming = [...incomingTenantInfos];
    copyIncoming.splice(index, 1);
    setIncomingTenantInfos(copyIncoming);
  };
  const changePreviousTenantInfos = (e: any, index: number) => {
    const copyPrevious = [...previousTenantInfos];
    copyPrevious[index] = { ...previousTenantInfos[index], [e.target.name]: e.target.value };
    setPreviousTenantInfos(copyPrevious);
  };

  const changeFormerTenantInfos = (e: any) => {
    setFormerTenantInfos({ firstname: e.target.firstname, lastname: e.target.lastname });
  };

  const addPreviousTenant = () => {
    setPreviousTenantInfos([
      ...previousTenantInfos,
      { firstname: '', name: '', phone: '', email: '', state: 'outgoing' }
    ]);
  };

  const deletePreviousTenant = (index: number) => {
    const copyPrevious = [...previousTenantInfos];
    copyPrevious.splice(index, 1);
    setPreviousTenantInfos(copyPrevious);
  };

  const [keysInfos, setKeysInfos] = useState({
    society: '',
    phone: '',
    email: '',
    address: '',
    further_information: '',
    contact_name: '',
    mobile: '',
    date: new Date(),
    moment: true
  });

  const ordersDetailsSheet = {
    orderId: '607', //uid of the order
    orderDate: new Date(), //date of the order
    category: 'entry',
    propertyState: 'vacant',
    property: {
      uid: '124',
      lessorName: '',
      batchNumber: '',
      address: {
        street: '255 Avenue du Prado',
        streetSupplement: '',
        residenceName: '',
        city: 'Marseille',
        zip: '13006',
        country: 'France'
      },
      addressDetails: {
        building: 'A',
        floor: '3',
        stairs: 'C',
        door: 'gauche',
        cellarNum: '',
        boxNum: '',
        parkingExtNum: '',
        parkingIntNum: ''
      },
      digicode: '616',
      owner: {
        firstname: 'Jean',
        lastname: 'Dupont'
      },
      tenant: {
        firstname: 'Bill',
        lastname: 'Potts'
      },
      isCondomium: false,
      category: 'Appartement',
      type: '2p',
      area: 250,
      lot: 1,
      title: 'Dupont - 255 avenue du prado lot n°1',
      buildYear: '1969'
    }
  };

  const activityFeedData: any = [
    {
      type: 'Intervenu',
      time: new Date(),
      data: ordersDetailsSheet
    },
    {
      type: 'Non intervenu',
      time: new Date(2022, 0, 25, 10, 30),
      data: ordersDetailsSheet
    },
    {
      type: 'Planifié',
      time: new Date(2022, 0, 23, 10, 30),
      additionnalInfo: new Date(2022, 0, 25, 10, 30), //necessary for planned
      data: ordersDetailsSheet
    },
    {
      type: 'Rappel 2',
      time: new Date(2022, 0, 21, 11, 30),
      data: ordersDetailsSheet
    },
    {
      type: 'Rappel 1',
      additionnalInfo: `etat des lieux de sortie`,
      time: new Date(2022, 0, 20, 11, 30),
      data: ordersDetailsSheet
    },
    {
      type: 'Attente Locataire',
      time: new Date(2022, 0, 10, 11, 30),
      data: ordersDetailsSheet
    }
  ];

  const [previewProps, setPreviewProps] = useState(ordersDetailsSheet);
  const tenantProps = {
    diagnostician,
    prestation,
    diagnosticDate,
    setDiagnosticDate,
    tenantInfos,
    changeTenantInfos,
    addIncomingTenant,
    addPreviousTenant,
    entryDate,
    setEntryDate,
    appointment,
    setAppointment,
    appointmentTime,
    incomingTenantInfos,
    setIncomingTenantInfos,
    setAppointmentTime,
    leavingTenantEntryDate,
    setLeavingTenantEntryDate
  }; 
  const previousTenantProps = { prestation, deletePreviousTenant, changePreviousTenantInfos };
  const incomingTenantProps = { prestation, deleteIncomingTenant, addIncomingTenant, changeIncomingTenantInfos };
  const formerTenantInfosProps = { formerTenantInfos, changeFormerTenantInfos };
  const keysProps = { keysInfos, setKeysInfos };

  return (
    <div className="mx-3 mt-0">
      <Button href="/my-orders" variant="link" className="backButton py-3">
        <i className="bi bi-chevron-left"></i> Toutes mes commandes
      </Button>
      <h1 className="mb-2 text-center text-lg-start d-lg-block">Ma commande</h1>
      <MyOrdersDetailsData
        category={category}
        setCategory={setCategory}
        preview={previewProps}
        setPreview={setPreviewProps}
        keys={keysProps}
        tenantProps={tenantProps}
        previousTenantProps={previousTenantProps}
        previousTenantInfos={previousTenantInfos}
        incomingTenantProps={incomingTenantProps}
        incomingTenantInfos={incomingTenantInfos}
        formerTenantInfosProps={formerTenantInfosProps}
        activityFeedData={activityFeedData}
      />
      <div className="d-flex flex-row justify-content-between gap-4 flex-wrap mt-3 mb-3">
        <div className="d-flex flex-row justify-content-start gap-2 flex-wrap">
          <Button
            onClick={() => archiveOrder()}
            className="archive-btn d-flex align-items-center justify-content-center"
            variant="primary"
          >
            <i style={{ fontSize: '18px' }} className="bi bi-folder-plus me-2"></i>
            Archiver ma commande
          </Button>
        </div>
        <div>
          <Button
            className="archive-btn d-flex align-items-center justify-content-center"
            variant="outline-danger"
            role="button"
            onClick={() => setShowOrderCancelModal(true)}
          >
            <i style={{ fontSize: '18px' }} className="bi bi-x me-2"></i>
            Supprimer la commande
          </Button>
          <ModalCancelOrder
            show={showOrderCancelModal}
            setShow={setShowOrderCancelModal}
            orderId={previewProps.orderId}
            date={previewProps.orderDate}
          />
        </div>
      </div>
    </div>
  );
};

export default MyOrdersDetails;
